export class CustexAddressModel {
    public id: number | undefined;
    public addressTypeId: CustexAddressTypes;
    public houseNameNumber: string;
    public line1: string;
    public line2: string;
    public line3?: string;
    public line4: string;
    public postCode: string;
}

export enum CustexAddressTypes {
    Delivery = 1,
    Billing = 2
}